import { Injectable } from '@angular/core';
import { checkBoolean, getInternalPrefUsr, truncString } from '@core/_utils/tools.utils';
import { defaultPage, doc_docid } from '@documalis/_const/const';
import { ConnectService } from './connect.service';

// parmamètres url
// 127.0.0.1:3100/#/login?search=index&cnx=bWFyaWU9SzF3JA
// login?
// search=index             : type de recherche valeurs possible : index, tree, wds
// &cnx=bWFyaWU9SzF3JA      : user/pass
// &displaymenu=true        : affichage menu : true, false

// recherche par index
// &reqname=aaa
// &parname1=xxx
// &parvalue1=yyy
// &parname2=xxx
// &parvalue2=yyy

// recherche arbo
// &root=Documents
// &path=\1.Privé\Marie Dupond\

// recherche plein text
// &root=Documents
// &path=\1.Privé\Marie Dupond\
// &text1=xx
// &text2=xx
// &text3=xx
// &text4=xx
// &datebegin=date format interne
// &dateend=date format interne

@Injectable()
export class ParamUrlService {
    public requestParam: any;
    public requestParamSys: any;
    public requestParamToUse: any;
    private _requestName: string;
    private _tree: boolean;
    private _fulltxt: boolean;
    private _root: string;
    private _path: string;
    private _basketName: string;
    private _text1: string;
    private _text2: string;
    private _text3: string;
    private _text4: string;
    private _datebegin: string;
    private _dateend: string;
    private _wordcond0: number;
    private _wordcond1: number;
    private _wordcond2: number;   
    private _formatType: string;   
    private _isReqSys: boolean;
    private _doc_docid: string;
    private _restricted: boolean;
    private _trunctree: boolean;
    private _filtertree: string;
    private _defaultPage: string;
    private _fromDash: boolean;
    public listIn: Array<any> = [];

    constructor(private connectService: ConnectService) {
        this.clear();
        this._restricted = false;
        this._trunctree = false;
    }

    public clear() {
        this.requestParam = null;
        this.requestParamSys = null;
        this.requestParamToUse = null;
        this._requestName = '';
        this._tree = false;
        this._fulltxt = false;
        this._root = '';
        this._path = '';
        this._basketName = '';
        this._text1 = '';
        this._text2 = '';
        this._text3 = '';
        this._text4 = '';
        this._datebegin = '';
        this._dateend = '';
        this._wordcond0 = 0;
        this._wordcond1 = 0;
        this._wordcond2 = 0;
        this._formatType = '';
        this._isReqSys = false;
        this._doc_docid = '';       
        this._filtertree = '';
        this._defaultPage = defaultPage;
        this._fromDash = false;
        this.listIn = [];
    }

    public async getContent(aContent) {
        let wRes: any;
        wRes = await this.connectService.getContent(aContent);
        return wRes;
    }

    public getPageFromUrl(aData, aDefault) {
        let wRes: string;
        let wNav: string;
        wRes = 'def';
        wNav = aDefault;
        if (aData !== undefined) {
            wRes = aData;
        }
        const type = {
            Variable: 'page-request-list',
            index: 'page-request-api',            
            tree: 'page-tree-api',
            wds: 'fulltextsearch',
            basket: 'page-basket-list',
            def: aDefault,
        }
        if (type[wRes]) {
            wNav = type[wRes];
        } else {
            wNav = 'notfound';
        }
        return wNav;
    }

    public getRestricted(aParams) {
        this._restricted = false;
        if (aParams['displaymenu']) {
            this._restricted = !checkBoolean(aParams['displaymenu']);
        }
        this.connectService.menu.setLogoutMenu(this.connectService.translate.instant('DisConnect')); 
    }

    public getFilter() {
        if (this._trunctree === true) {
            return this._filtertree.replace(/\//g, '_');
        } else {
            return '';
        }
    }

    public getRequestParams(aReq, aParams) {
        this.clear();
        switch (aReq) {
            case 'page-request-list': {
                this.getParamsIndex(aParams);
                break;
            }
            case 'page-request-api': {
                this.getParamsIndex(aParams);
                break;
            }            
            case 'page-tree-search': {
                this.getParamsTree(aParams);
                break;
            }
            case 'page-tree-api': {
                this.getParamsTree(aParams);
                break;
            }            
            case 'fulltextsearch': {
                this.getParamsWds(aParams);
                break;
            }
            case 'page-basket-list': {
                this.getParamsBsk(aParams);
                break;
            }
            default: {
                break;
            }
        }
    }

    public getDefaulPage() {
        let wInternalPrefUsr: any;
        this._defaultPage = defaultPage;
        if (localStorage.getItem('internalprefusr')) {
            wInternalPrefUsr = getInternalPrefUsr();
            if (wInternalPrefUsr.defaultPage !== undefined) {
                this._defaultPage = wInternalPrefUsr.defaultPage;
            }
        }
        return this._defaultPage;
    }

    private getParamsIndex(aData) {
        let wParam: any;
        let wData = [];
        let wDataName = [];
        let wDataValue = [];
        let wIdx;
        this._requestName = '';
        Object.keys(aData).forEach((key) => {
            if (key === 'reqname') {
                this._requestName = this.getValue(aData[key]);
            }
            if (key.substring(0, 7) === 'parname') {
                this.setArrayParam(key, 7, aData[key], wDataName);
            }
            if (key.substring(0, 8) === 'parvalue') {
                this.setArrayParam(key, 8, aData[key], wDataValue);
            }
        });

        wDataName.forEach((item) => {
            wIdx = wDataValue.find((elem) => {
                return elem.name === item.name;
            });
            if (wIdx !== undefined) {
                wParam = new Object();
                wParam.name = item.value;
                wParam.value = wIdx.value;
                wData.push(wParam);
            }
        });
        this.requestParam = wData;
    }

    public setParamsIndex(aVariableList) {
        let wIndex = -1;
        aVariableList.forEach((item) => {
            wIndex = -1;
            wIndex = this.requestParam.findIndex((elem) => {
                return elem.name === item.name;
            });
            if (wIndex !== -1) {
                item.DefaultValue = this.requestParam[wIndex].value;
                item.valdefault = this.requestParam[wIndex].value;
                item.value = this.requestParam[wIndex].value;
                this.requestParam.splice(wIndex, 1);
            }
        });
    }

    public setParamsToUse(aVariableList) {
        let wIndex = -1;
        let wValue: any;
        if (this.requestParamToUse.paramrequest.CriteriaList.length !== 0) {
            aVariableList.forEach((item, index) => {
                wIndex = -1;
                wIndex = this.requestParamToUse.paramrequest.CriteriaList.findIndex((elem) => {
                    return elem.Criteria.Name === item.name;
                });
                if (wIndex !== -1) {
                    if ((this.requestParamToUse.paramrequest.CriteriaList[wIndex].Criteria.OperatorType === 'TIn' || 
                    this.requestParamToUse.paramrequest.CriteriaList[wIndex].Criteria.OperatorType.OperatorType === '"TNotIn"') &&
                    this.requestParamToUse.paramrequest.CriteriaList[wIndex].Criteria.FieldType !== 'TextArea') {
                        wValue = this.requestParamToUse.paramrequest.CriteriaList[wIndex].Criteria.Value.split(',');
                        this.listIn.push({name:this.requestParamToUse.paramrequest.CriteriaList[wIndex].Criteria.Name,
                                        value: wValue});
                    } else {
                        wValue = this.requestParamToUse.paramrequest.CriteriaList[wIndex].Criteria.Value;
                        item.DefaultValue = wValue;
                        item.valdefault = wValue;
                        item.value = wValue;
                    }
                    this.requestParamToUse.paramrequest.CriteriaList.splice(wIndex, 1);
                }                
            });
        }        
    }

    public prepareUrlSys(aReqSysName, aListId, aDocDocid) {
        let wParam: any;
        this.requestParam = [];
        wParam = new Object();
        wParam.name = doc_docid.name;
        wParam.value = '';
        aListId.forEach((item) => {
            wParam.value = wParam.value + item.doc_docid + ',';
        });
        wParam.value = truncString(wParam.value, 1);
        this.requestParam.push(wParam);
        this.requestName = aReqSysName;
        this.isReqSys = true;
        this.doc_docid = aDocDocid;
    }

    private setArrayParam(aKey, aLength, aData, aArray) {
        let wParam: any;
        let wIdx;
        wIdx = Number(aKey.substring(aLength));
        if (typeof wIdx === 'number') {
            wParam = new Object();
            wParam.name = wIdx;
            wParam.value = this.getValue(aData);
            aArray.push(wParam);
        }
    }

    private getValue(aValue) {
        if (this.isReqSys === false) {
            return atob(aValue);
        } else {
            return aValue;
        }
    }

    private getParamsTree(aData) {
        if (JSON.stringify(aData) === '{}') {
            this._tree = false;            
            return;
        } 
        this._tree = true;
        Object.keys(aData).forEach((key) => {
            if (key === 'root') {
                this._root = atob(aData[key]);
            }
            if (key === 'path') {
                this._path = atob(aData[key]);
            }
            if (key=== 'trunctree') {
                this._trunctree = checkBoolean(aData[key]);             
            }
            if (key=== 'filtertree') {
                this._filtertree = atob(aData[key]);          
            }            
        });
    }

    private getParamsBsk(aData) {
        this._basketName = '';
        Object.keys(aData).forEach((key) => {
            if (key === 'basketname') {
                this._basketName = aData[key];
            }
        });
    }

    private getParamsWds(aData) {
        if (JSON.stringify(aData) === '{}') {
            this._fulltxt = false;            
            return;
        } 
        this._fulltxt = true;
        Object.keys(aData).forEach((key) => {
            if (key === 'root') {
                this._root = atob(aData[key]);
            }
            if (key === 'path') {
                this._path = atob(aData[key]);
            }
            if (key === 'text1') {
                this._text1 = atob(aData[key]);
            }
            if (key === 'text2') {
                this._text2 = atob(aData[key]);
            }
            if (key === 'text3') {
                this._text3 = atob(aData[key]);
            }
            if (key === 'text4') {
                this._text4 = atob(aData[key]);
            }
            if (key === 'datebegin') {
                this._datebegin = atob(aData[key]);
            }
            if (key === 'dateend') {
                this._dateend = atob(aData[key]);
            }
        });
    }

    get requestName() {
        return this._requestName;
    }

    set requestName(aValue) {
        this._requestName = aValue;
    }

    get tree() {
        return this._tree;
    }

    set tree(aValue) {
        this._tree = aValue;
    }

    get basketName() {
        return this._basketName;
    }

    set basketName(aValue) {
        this._basketName = aValue;
    }

    get fulltxt() {
        return this._fulltxt;
    }

    set fulltxt(aValue) {
        this._fulltxt = aValue;
    }

    get root() {
        return this._root;
    }

    set root(aValue) {
        this._root = aValue;
    }

    get path() {
        return this._path;
    }

    set path(aValue) {
        this._path = aValue;
    }

    get text1() {
        return this._text1;
    }

    set text1(aValue) {
        this._text1 = aValue;
    }

    get text2() {
        return this._text2;
    }

    set text2(aValue) {
        this._text2 = aValue;
    }

    get text3() {
        return this._text3;
    }

    set text3(aValue) {
        this._text3 = aValue;
    }

    get text4() {
        return this._text4;
    }

    set text4(aValue) {
        this._text4 = aValue;
    }

    get datebegin() {
        return this._datebegin;
    }

    set datebegin(aValue) {
        this._datebegin = aValue;
    }

    get dateend() {
        return this._dateend;
    }

    set dateend(aValue) {
        this._dateend = aValue;
    }

    get isReqSys() {
        return this._isReqSys;
    }

    set isReqSys(aValue) {
        this._isReqSys = aValue;
    }

    get doc_docid() {
        return this._doc_docid;
    }

    set doc_docid(aValue) {
        this._doc_docid = aValue;
    }

    get restricted() {
        return this._restricted;
    }

    set restricted(aValue) {
        this._restricted = aValue;
    }

    get trunctree() {
        return this._trunctree;
    }

    set trunctree(aValue) {
        this._trunctree = aValue;
    }

    get filtertree() {
        return this._filtertree;
    }

    set filtertree(aValue) {
        this._filtertree = aValue;
    }   

    get defaultPage() {
        return this._defaultPage;
    }

    set defaultPage(aValue) {
        this._defaultPage = aValue;
    }   

    get wordcond0() {
        return this._wordcond0
    }

    set wordcond0(aValue) {
        this._wordcond0 = aValue;
    }

    get wordcond1() {
        return this._wordcond1
    }

    set wordcond1(aValue) {
        this._wordcond1 = aValue;
    }

    get wordcond2() {
        return this._wordcond2;
    }

    set wordcond2(aValue) {
        this._wordcond2 = aValue;
    }

    get formatType() {
        return this._formatType;
    }

    set formatType(aValue) {
        this._formatType = aValue;
    }

    get fromDash() {
        return this._fromDash;
    }

    set fromDash(aValue) {
        this._fromDash = aValue;
    }
}
